import React from 'react'

import LocalDrink from '@material-ui/icons/LocalDrink'
import LocalHospital from '@material-ui/icons/LocalHospital'
import DirectionsBusIcon from '@material-ui/icons/DirectionsBus'
import NatureIcon from '@material-ui/icons/NaturePeople'
import WorkIcon from '@material-ui/icons/LocationCity'
import People from '@material-ui/icons/People'
import SportsBaseballRoundedIcon from '@material-ui/icons/Work'
import TrendingUpIcon from '@material-ui/icons/TrendingUp'

const icons = [
  {
    id: 'Agua, Saneamiento e Infraestructura Hídrica',
    color: '#61B6E7',
    path: (
      <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" width="35" viewBox="0 0 29.33 29.33">
        <svg focusable="false" width="35" viewBox="0 -2 30.33 30.33" aria-hidden="true">
          <path id="Trazado_468" data-name="Trazado 468" d="M22.671,122.5c0-4.27,5.967-13.4,8.8-17.489a1.771,1.771,0,0,1,2.928,0c2.835,4.092,8.8,13.219,8.8,17.489a10.267,10.267,0,1,1-20.534,0m5.6,0a.934.934,0,0,0-1.867,0,6.542,6.542,0,0,0,6.534,6.586.933.933,0,1,0,0-1.866,4.677,4.677,0,0,1-4.667-4.72" transform="translate(-22.671 -104.24)" />
        </svg>

      </svg>

    )
  },
  {
    id: 'Cultura y Educación',
    color: '#F9BB23',
    path: (

      <svg xmlns="http://www.w3.org/2000/svg" width="40" viewBox="0 -5 32.33 32.33">
        <path id="Trazado_473" data-name="Trazado 473" d="M48.526,268.011,33.987,262.8a3.231,3.231,0,0,0-2.182,0l-14.5,5.209a1.269,1.269,0,0,0,0,2.378l3.086,1.107a7.114,7.114,0,0,0-1.262,2.776,1.649,1.649,0,0,0-1,1.516,1.62,1.62,0,0,0,.614,1.254l-1.277,7.669a.824.824,0,0,0,.812.96h2.994a.823.823,0,0,0,.811-.959L20.8,277.043a1.692,1.692,0,0,0,.613-1.255,1.619,1.619,0,0,0-.653-1.281,5.475,5.475,0,0,1,1.282-2.421l9.8,3.513a3.243,3.243,0,0,0,2.182,0l14.538-5.209a1.261,1.261,0,0,0,.826-1.19,1.241,1.241,0,0,0-.869-1.189m-13.989,9.136a4.423,4.423,0,0,1-1.6.289,4.864,4.864,0,0,1-1.645-.287l-7.467-2.673-.762,7.35c0,2.126,4.377,3.845,9.874,3.845,5.406,0,9.875-1.719,9.875-3.843l-.76-7.356Z" transform="translate(-16.48 -262.612)" />
        ,
      </svg>
    )
  },
  {
    id: 'Conectividad Multimodal e Infraestructura del Transporte',
    color: '#50B7B2',
    path: (
      <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" width="35" viewBox="0 0 29.33 29.33">
        <svg xmlns="http://www.w3.org/2000/svg" width="25.458" height="29.119" viewBox="0 0 25.458 29.119">
          <path id="Trazado_472" data-name="Trazado 472" d="M32.938,155.944c7.092,0,12.729,2,12.729,4.55V179.6a1.817,1.817,0,0,1-1.818,1.82v1.82a1.818,1.818,0,0,1-1.819,1.82H40.212a1.818,1.818,0,0,1-1.819-1.82v-1.82H27.483v1.82a1.818,1.818,0,0,1-1.819,1.82H23.846a1.819,1.819,0,0,1-1.818-1.82v-1.82a1.819,1.819,0,0,1-1.819-1.82V160.494c0-2.548,5.637-4.55,12.729-4.55M23.846,170.5a1.818,1.818,0,0,0,1.818,1.819H40.212A1.816,1.816,0,0,0,42.03,170.5v-7.28a1.817,1.817,0,0,0-1.818-1.82H25.664a1.818,1.818,0,0,0-1.818,1.82Zm.909,8.189a1.82,1.82,0,1,0-1.818-1.82,1.818,1.818,0,0,0,1.818,1.82m16.366,0a1.82,1.82,0,1,0-1.818-1.82,1.817,1.817,0,0,0,1.818,1.82" transform="translate(-20.209 -155.944)" />
        </svg>
      </svg>
    )
  },
  {
    id: 'Infraestructura de Salud, Cuidados y Género',
    color: '#EF5350',
    path: (
      <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" width="40" viewBox="0 0 25.33 25.33">
        <svg xmlns="http://www.w3.org/2000/svg" width="25.035" height="25.057" viewBox="-1 -3 29.035 29.057">
          <path id="Trazado_471" data-name="Trazado 471" d="M43.16,365.155H22.715a2.3,2.3,0,0,0-2.3,2.3v20.463a2.3,2.3,0,0,0,2.3,2.3H43.16a2.3,2.3,0,0,0,2.3-2.3V367.452a2.3,2.3,0,0,0-2.3-2.3m-1.877,14.86a.1.1,0,0,1-.1.1h-5.7a.1.1,0,0,0-.105.1v5.708a.1.1,0,0,1-.1.105H30.608a.1.1,0,0,1-.1-.105v-5.708a.1.1,0,0,0-.1-.1H24.7a.1.1,0,0,1-.105-.1v-4.664a.1.1,0,0,1,.105-.1h5.7a.1.1,0,0,0,.1-.1v-5.708a.1.1,0,0,1,.1-.1h4.659a.1.1,0,0,1,.1.1v5.708a.1.1,0,0,0,.105.1h5.7a.1.1,0,0,1,.1.1Z" transform="translate(-20.42 -365.155)" />
        </svg>
      </svg>
    )
  },
  {
    id: 'Ambiente y Demarcación',
    color: '#4FBB73',
    path: (
      <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" width="35" viewBox="0 -5 32.33 32.33">
      <path id="Trazado_469" data-name="Trazado 469" d="M40.32,213.122a3.692,3.692,0,1,1,3.692,3.692,3.691,3.691,0,0,1-3.692-3.692M18.171,230.477a2.575,2.575,0,0,1,.4-1.37l10-15.938a1.676,1.676,0,0,1,2.838,0l5.81,9.261,2.224-3.646a.989.989,0,0,1,.881-.493,1.039,1.039,0,0,1,.882.493l6.091,9.986a2.821,2.821,0,0,1-2.409,4.287H20.751a2.606,2.606,0,0,1-2.58-2.58" transform="translate(-18.171 -209.43)" />
    </svg>

    )
  },
  {
    id: 'Sistemas Sociodemográficos',
    color: '#EC407A',
    path: (
      <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" width="35" viewBox="0 0 29.33 29.33">
      <People/>
    </svg>
    )
  },
  {
    id: 'Ambiente y Demarcación',
    color: '#4FBB73',
    path: (

      <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" width="35" viewBox="0 -5 32.33 32.33">
        <path id="Trazado_469" data-name="Trazado 469" d="M40.32,213.122a3.692,3.692,0,1,1,3.692,3.692,3.691,3.691,0,0,1-3.692-3.692M18.171,230.477a2.575,2.575,0,0,1,.4-1.37l10-15.938a1.676,1.676,0,0,1,2.838,0l5.81,9.261,2.224-3.646a.989.989,0,0,1,.881-.493,1.039,1.039,0,0,1,.882.493l6.091,9.986a2.821,2.821,0,0,1-2.409,4.287H20.751a2.606,2.606,0,0,1-2.58-2.58" transform="translate(-18.171 -209.43)" />
      </svg>

    )
  },
  {
    id: 'Sistema Sociodemográfico',
    color: '#9284BE',
    path: (
      <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" width="35" viewBox="0 0 29.33 29.33">
        <svg className="MuiSvgIcon-root jss88" focusable="false" viewBox="0 0 24 24" aria-hidden="true" tabIndex="-1" title="People" data-ga-event-category="material-icons" data-ga-event-action="click" data-ga-event-label="People">
          <path d="M16 11c1.66 0 2.99-1.34 2.99-3S17.66 5 16 5c-1.66 0-3 1.34-3 3s1.34 3 3 3zm-8 0c1.66 0 2.99-1.34 2.99-3S9.66 5 8 5C6.34 5 5 6.34 5 8s1.34 3 3 3zm0 2c-2.33 0-7 1.17-7 3.5V19h14v-2.5c0-2.33-4.67-3.5-7-3.5zm8 0c-.29 0-.62.02-.97.05 1.16.84 1.97 1.97 1.97 3.45V19h6v-2.5c0-2.33-4.67-3.5-7-3.5z" />
        </svg>
      </svg>
    )
  },
  {
    id: 'Asentamientos, Sistemas de Ciudades e Infraestructuras',
    color: '#F79525',
    path: (
      <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" width="35" viewBox="18 8 32.33 32.33">
        <path id="Trazado_549" data-name="Trazado 549" d="M-47.468,518.971a2.888,2.888,0,0,1,2.886,2.889v25.032a2.888,2.888,0,0,1-2.886,2.888H-53.24v-4.814a2.888,2.888,0,0,0-2.886-2.888,2.888,2.888,0,0,0-2.886,2.888v4.814h-5.772a2.887,2.887,0,0,1-2.886-2.888V521.86a2.888,2.888,0,0,1,2.886-2.889Zm-16.354,16.368a.964.964,0,0,0,.963.962h1.923a.964.964,0,0,0,.962-.962v-1.926a.965.965,0,0,0-.962-.963h-1.923a.965.965,0,0,0-.963.963Zm6.735-2.889a.966.966,0,0,0-.963.963v1.926a.965.965,0,0,0,.963.962h1.923a.965.965,0,0,0,.962-.962v-1.926a.966.966,0,0,0-.962-.963Zm4.809,2.889a.965.965,0,0,0,.962.962h1.924a.965.965,0,0,0,.962-.962v-1.926a.966.966,0,0,0-.962-.963h-1.924a.966.966,0,0,0-.962.963Zm-10.581-10.591a.964.964,0,0,0-.963.963v1.925a.964.964,0,0,0,.963.963h1.923a.965.965,0,0,0,.962-.963v-1.925a.965.965,0,0,0-.962-.963Zm4.809,2.888a.965.965,0,0,0,.963.963h1.923a.965.965,0,0,0,.962-.963v-1.925a.965.965,0,0,0-.962-.963h-1.923a.965.965,0,0,0-.963.963Zm6.734-2.888a.965.965,0,0,0-.962.963v1.925a.965.965,0,0,0,.962.963h1.924a.965.965,0,0,0,.962-.963v-1.925a.965.965,0,0,0-.962-.963Z" transform="translate(89.972 -508.472)" />
      </svg>
    )
  },
  {
    id: 'Actividad Económica, Empleo y Pobreza',
    color: '#EF5350',
    path: (
      <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" width="35" viewBox="18 8 32.33 32.33">
        <path id="Trazado_470" data-name="Trazado 470" d="M17.6,423.216v17.269a2.95,2.95,0,0,0,2.876,2.878h2.876V420.338H20.476a2.95,2.95,0,0,0-2.876,2.878m20.13-8.634H28.144a2.949,2.949,0,0,0-2.875,2.878v25.9H40.606v-25.9a2.95,2.95,0,0,0-2.876-2.878m0,5.756H28.144V417.46H37.73Zm7.669,0H42.523v23.025H45.4a2.949,2.949,0,0,0,2.875-2.878V423.216a2.949,2.949,0,0,0-2.875-2.878" transform="translate(1 -403.413)" />
      </svg>
    )
  },
  {
    id: 'tour',
    path: (
      <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" width="35" viewBox="0 0 29.33 29.33">
        <TrendingUpIcon />
      </svg>
    )
  },
  {
    id: 'Información de Gestión e Inversión Pública',
    color: '#EF6C00',
    path: (
      <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" width="35" viewBox="17 8 32.33 32.33">
        <path id="Trazado_475" data-name="Trazado 475" d="M47.939,483.086c0-5.438-3.771-10.087-8.514-12.039l-3.2,5.532V468.99a1.079,1.079,0,0,0-1.084-1.084H29.509a1.08,1.08,0,0,0-1.085,1.084v7.587l-3.2-5.528c-4.743,1.95-8.514,6.6-8.514,12.037v4.336H47.938Zm1.873,6.879a.973.973,0,0,0-.9-.591H15.737a.976.976,0,0,0-.709,1.646c.163.171,4.127,4.208,17.243,4.208s17.083-4.036,17.3-4.208a.908.908,0,0,0,.245-1.055" transform="translate(0.875 -455.649)" />
      </svg>
    )
  },
  {
    id: 'tutorial',
    path: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="30.547"
        viewBox="0 0 469.038 469.038"
      >
        <g>
          <path d="M465.023,4.079c-3.9-3.9-9.9-5-14.9-2.8l-442,193.7c-4.7,2.1-7.8,6.6-8.1,11.7s2.4,9.9,6.8,12.4l154.1,87.4l91.5,155.7
c2.4,4.1,6.9,6.7,11.6,6.7c0.3,0,0.5,0,0.8,0c5.1-0.3,9.5-3.4,11.6-8.1l191.5-441.8C470.123,13.879,469.023,7.979,465.023,4.079z
M394.723,54.979l-226.2,224.7l-124.9-70.8L394.723,54.979z M262.223,425.579l-74.5-126.9l227.5-226L262.223,425.579z"
          />
        </g>
      </svg>

    )
  },
  {
    id: 'contact',
    path: (
      <svg xmlns="http://www.w3.org/2000/svg" stroke="currentColor" width="19.547" height="20.787" viewBox="0 0 19.547 20.787">
        <g id="Grupo_48" data-name="Grupo 48" transform="translate(-51.076 -679.996)">
          <line id="Línea_4" data-name="Línea 4" x1="9.202" transform="translate(56.248 686.855)" fill="none" strokeLinecap="round" strokeMiterlimit="10" strokeWidth="1.688" />
          <line id="Línea_5" data-name="Línea 5" x1="9.202" transform="translate(56.248 690.654)" fill="none" strokeLinecap="round" strokeMiterlimit="10" strokeWidth="1.688" />
          <path id="Trazado_12" data-name="Trazado 12" d="M51.919,699.94l5.791-4.186H69.779V680.84H51.919Z" fill="none" strokeLinejoin="round" strokeMiterlimit="10" strokeWidth="1.688" />
        </g>
      </svg>
    )
  },
  {
    id: 'lupa',
    path: (
      <svg id="Capa_1" data-name="Capa 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 22 22">
        <defs>
          <style>.cls-1 fill:#0072bb</style>
        </defs>
        <title>Sin título-4</title>
        <path className="cls-1" d="M9.28,4.66A4.56,4.56,0,0,0,4.73,9.21.63.63,0,0,0,6,9.21,3.3,3.3,0,0,1,9.28,5.92a.63.63,0,0,0,0-1.26Z" />
        <path className="cls-1" d="M19.46,18l-4.65-4.65A7,7,0,1,0,13,15l4.73,4.73a.81.81,0,0,0,1.14,0l.57-.57A.81.81,0,0,0,19.46,18ZM9.28,14.78A5.72,5.72,0,1,1,15,9.06,5.73,5.73,0,0,1,9.28,14.78Z" />
      </svg>
    )
  }, {
    id: 'obras y proyectos',
    path: (
      <svg className="MuiSvgIcon-root MuiSvgIcon-fontSizeMedium MuiSvgIcon-root MuiSvgIcon-fontSizeLarge css-zjt8k" focusable="false" aria-hidden="true" viewBox="0 0 24 24" data-testid="ConstructionIcon" title="Construction"><path d="m13.7826 15.1719 2.1213-2.1213 5.9963 5.9962-2.1213 2.1213zM17.5 10c1.93 0 3.5-1.57 3.5-3.5 0-.58-.16-1.12-.41-1.6l-2.7 2.7-1.49-1.49 2.7-2.7c-.48-.25-1.02-.41-1.6-.41C15.57 3 14 4.57 14 6.5c0 .41.08.8.21 1.16l-1.85 1.85-1.78-1.78.71-.71-1.41-1.41L12 3.49c-1.17-1.17-3.07-1.17-4.24 0L4.22 7.03l1.41 1.41H2.81l-.71.71 3.54 3.54.71-.71V9.15l1.41 1.41.71-.71 1.78 1.78-7.41 7.41 2.12 2.12L16.34 9.79c.36.13.75.21 1.16.21z" /></svg>
    )
  }
]

export default icons
